// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29keK","right":"styles_right__OKmc2"};